import axios from "axios";
import { getAccessToken } from "lib/accessToken";
import { Error } from "lib/common/types/ErrorResponse";
import { useCallback, useEffect, useState } from "react";
import parseJwt from "utils/helper/jwtParser";
import { useAppDispatch } from "../../../redux/hooks";
import { onBoardUser } from "../../../redux/reducers/userSlice";
import { host } from "../../../utils/constants";
import useGetMe from "../useGetMe";
import { User } from "lib/common/types/user";
import { message } from "antd";
function useOnboardReqWithBearerToken() {
  const { fetchUser } = useGetMe();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [success, setSuccess] = useState(false);
  const dispatch = useAppDispatch();
  const [message_, setMessage] = useState("");

  useEffect(() => {
    if (error && error.message) {
      message?.error(error.message);
    } else if (message) {
      message?.success(message_);
    }
  }, [error, message_]);

  const reqWithBearerToken = useCallback(
    (operation, value, request = "post") => {
      setLoading(true);
      setError(null);

      axios({
        method: request,
        url: host + `/auth/register/${operation}`,
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
        data: value,
      })
        .then(({ data: { data, success, message } }) => {
          setMessage(message);
          if (data) {
            setSuccess(success);
            fetchUser().then((user) => {
              dispatch(
                onBoardUser({
                  user: user as User,
                  isAdmin: parseJwt(data.accessToken).isAdminUser,
                  isSuperAdmin: parseJwt(data.accessToken).isSuperAdminUser,
                  onBoardingStatus: data.onBoardingStatus,
                })
              );
            });

            localStorage.removeItem("registerData");
          }
        })
        .catch((err) => {
          setError(err.response.data);
        })
        .finally(() => setLoading(false));
    },
    [dispatch, fetchUser]
  );

  return { reqWithBearerToken, loading, error, success };
}

export default useOnboardReqWithBearerToken;
